import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var payOverTimeIcon = /*#__PURE__*/React.createElement("svg", {
  height: "48",
  width: "48",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.999 48C.393 48 0 47.572 0 47.006V27.99c0-.605.28-.932.838-.983C.885 27.003.931 27 .98 27l-.125.006A1.8 1.8 0 0 1 .999 27l-.092.003L.98 27h31.023c.606 0 .999.428.999.994V47.01c0 .605-.28.932-.838.983a1.492 1.492 0 0 1-.142.007l.125-.006a1.8 1.8 0 0 1-.144.006l.102-.004-.083.004Zm30.008-18.996H1.994v16.992l29.013-.001v-16.99Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.337 18H5.98c-.627 0-.98.427-.98.994v6.999c1.326-.004 1.988-.5 1.988-1.488v-4.5h29.02v17.002h-.489c-1.015 0-1.523.664-1.523 1.993h3.007c.666 0 .999-.33.999-.99V18.994c0-.566-.393-.994-.999-.994H23.641"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.337 9H10.98c-.627 0-.98.427-.98.994v6.999c1.326-.004 1.988-.5 1.988-1.488v-4.5h29.02v17.002h-.489c-1.015 0-1.523.664-1.523 1.993h3.007c.666 0 .999-.33.999-.99V9.994c0-.566-.393-.994-.999-.994H28.641"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.337 0H15.98c-.627 0-.98.427-.98.994v6.999c1.326-.004 1.988-.5 1.988-1.488v-4.5h29.02v17.002h-.489c-1.015 0-1.523.664-1.523 1.993h3.007c.666 0 .999-.33.999-.99V.994c0-.566-.393-.994-.999-.994H33.641M16.02 32h1.976L14 39h3.005v-1.99h1.997V39c1.075 0 1.596.665 1.563 1.995h-1.563v1.998h-1.997v-1.998H12V39l4.02-7Z"
})));

export { payOverTimeIcon as default };
//# sourceMappingURL=payOverTimeIcon.js.map
